<template>
  <div>
    <h1>Suspender Concesión {{ $route.params.concesionNumber }}</h1>
    <div class="card">
      <div class="card-body">
        <a-form :form="form" @submit.prevent="handleSubmit" layout="vertical">
          <div class="row">
            <div class="col-md-6">
              <label>Evidencia (adjuntar archivo .jpg, .png, .pdf)</label>
              <b-form-file
                v-model="$v.advice.file.$model"
                ref="file"
                :state="fileState"
                placeholder="Evidencia"
                browse-text="Adjuntar"
                drop-placeholder="Drop file here..."
                @change="onFileSelected"
                required
                accept="application/pdf,image/x-png,image/gif,image/jpeg"
                ></b-form-file>
            </div>
            <div class="col-md-6">
              <a-form-item label="Motivo de baja">
                <a-input ref="name" placeholder="Motivo de baja" v-model="$v.advice.razon.$model" />
                <small class="text-danger" v-if="!$v.advice.razon.required">Campo requerido. No debe estar vacío.</small><br>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Periodo de retorno">
                <a-month-picker placeholder="Periodo de retorno" v-model="$v.advice.periodoRetorno.$model" :disabled-date="disabledDate" @change="onChangePeriod" style="width: 100%" />
                <!--<a-input ref="name" placeholder="Motivo de baja" v-model="$v.advice.periodoRetorno.$model" />-->
                <small class="text-danger" v-if="!$v.advice.periodoRetorno.required">Campo requerido. No debe estar vacío.</small><br>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item
                label="Fecha de inicio de la suspensión"
                has-feedback>
                <a-date-picker placeholder="Seleccionar fecha" :disabled-date="disabledDate" @change="changeFechaInicioDate" v-model="advice.fechaInicio" style="width: 100%" />
                <small class="text-danger" v-if="!$v.advice.fechaInicio.required">Campo requerido. No debe estar vacío</small><br>
                <small class="text-danger" v-if="!(Date.parse(advice.fechaFin) >= Date.parse(advice.fechaInicio))">La fecha de fin de la suspensión debe ser mayor que la fecha de inicio de la suspensión</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item
                label="Fecha de fin de la suspensión"
                has-feedback>
                <a-date-picker placeholder="Seleccionar fecha" :disabled-date="disabledDate" @change="changeFechaFinDate" v-model="advice.fechaFin" style="width: 100%" />
                <small class="text-danger" v-if="!$v.advice.fechaFin.required">Campo requerido. No debe estar vacío</small><br>
                <small class="text-danger" v-if="!(Date.parse(advice.fechaFin) >= Date.parse(advice.fechaInicio))">La fecha de fin de la suspensión debe ser mayor que la fecha de inicio de la suspensión</small>
              </a-form-item>
            </div>
            <!--{{ Date.parse(advice.fechaFin) >= Date.parse(advice.fechaInicio) }}
            {{ $v.$invalid }}-->
            <div class="col-12">
              <a-form-item>
                <button
                  :disabled="!(!$v.$invalid && (Date.parse(advice.fechaFin) >= Date.parse(advice.fechaInicio)))"
                  type="submit"
                  class="btn btn-light px-5">
                  Guardar
                </button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'
import { uploadFileS3 } from '../../../s3/s3Up.js'
import headers from '@/config/headers.js'
const CREATE_CONCESION_ADVICE = gql`
  mutation createConcesionAdvice($razon: String, $periodoRetorno: String, $concesionNumber: String, $fechaInicio: String, $fechaFin: String, $fileUrl: String, $rfc: String, $autorizedBy: String, $requestedBy: String){
    createConcesionAdvice(advice: { razon: $razon periodoRetorno: $periodoRetorno concesionNumber: $concesionNumber fechaInicio: $fechaInicio fechaFin: $fechaFin fileUrl: $fileUrl rfc: $rfc autorizedBy: $autorizedBy requestedBy: $requestedBy }) {
      message
      success
    }
  }
`
const CONCESION_OUT_SERVICE = gql`
  mutation concesionOutService($concesionId: Int) {
    concesionOutService(concesionId: $concesionId){
      id
      concesionarioId
      concesionNumber
    }
  }
`
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      advice: {
        razon: '',
        periodoRetorno: '',
        fechaFin: '',
        fechaInicio: '',
        file: null,
      },
      fileState: null,
      autorizedBy: this.$store.state.user.email,
      requestedBy: this.$store.state.user.email,
      concesionNumber: this.$route.params.concesionNumber,
      rfc: this.$route.params.concesionario.rfc,
    }
  },
  methods: {
    async handleSubmit() {
      const file = []
      file.fileExtension = this.advice.file.name.split('.').pop()
      file.fileUploaded = this.advice.file
      const uploadedFile = await uploadFileS3(file)
      this.$apollo.mutate({
        mutation: CREATE_CONCESION_ADVICE,
        context: headers(),
        variables: {
          razon: this.advice.razon,
          periodoRetorno: this.advice.periodoRetorno,
          concesionNumber: String(this.concesionNumber),
          fechaInicio: this.advice.fechaInicio,
          fechaFin: this.advice.fechaFin,
          fileUrl: uploadedFile.Location,
          rfc: this.rfc,
          autorizedBy: this.autorizedBy,
          requestedBy: this.requestedBy,
        },
      })
        .then(data => {
          console.log(data)
          this.$apollo.mutate({
            mutation: CONCESION_OUT_SERVICE,
            context: headers(),
            variables: {
              concesionId: parseInt(this.$route.params.id),
            },
          })
            .then(data => {
              console.log(data)
              this.$router.push({ name: 'getConcesiones' })
            })
            .catch(error => {
              console.log(error)
            })
        })
        .catch(error => {
          console.log(error)
        })
    },
    onFileSelected(event) {
      this.advice.file = event.target.files[0]
    },
    disabledDate(current) {
      return current < moment().add(-1, 'days')
    },
    onChangePeriod(date, dateString) {
      // console.log(dateString)
      this.advice.periodoRetorno = dateString
      /*
      if (event) {
        // console.log(event)
        console.log(new Date(this.defineDate(event._d)).getUTCMonth())
        this.advice.periodoRetorno = this.defineDate(event._d)
      } else {
        this.todayDate()
      } */
    },
    changeFechaInicioDate(event) {
      if (event) {
        this.advice.fechaInicio = this.defineDate(event._d)
      } else {
        this.todayDate()
      }
    },
    changeFechaFinDate(event) {
      if (event) {
        this.advice.fechaFin = this.defineDate(event._d)
      } else {
        this.todayDate()
      }
    },
    defineDate(date) {
      const dates = new Date(date)
      const year = (dates.getFullYear())
      var month = (parseInt(dates.getMonth() + 1))
      var day = (dates.getDate())
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      return [year, month, day].join('-')
    },
  },
  created() {
    console.log(this.$route.params)
  },
  validations: {
    advice: {
      razon: { required },
      periodoRetorno: { required },
      fechaFin: { required },
      fechaInicio: { required },
      file: { required },
    },
  },
}
</script>
